'use strict';

import * as queryString from 'query-string';

const $Q = Symbol('$q');
const $WINDOW = Symbol('window');
const $TIMEOUT = Symbol('$timeout');
const $INTERVAL = Symbol('$interval');
const $HTTP = Symbol('$http');
const API = Symbol('api');
const QS = Symbol('query string');
const SOCKET = Symbol('socket service');
const DEVICE_DETECTOR = Symbol('deviceDetector');
const ANALYTICS_SERVICE = Symbol('analyticsService');

class ActivateController {
  constructor($q, $window, $timeout, $interval, apiService, $http, analyticsService,
    deviceDetector, silentDownloadUrl, socketService, downloadUrlsService) {
    'ngInject';

    const md = new MobileDetect($window.navigator.userAgent);

    this[$Q] = $q;
    this[$WINDOW] = $window;
    this[$TIMEOUT] = $timeout;
    this[$INTERVAL] = $interval;
    this[API] = apiService;
    this[DEVICE_DETECTOR] = deviceDetector;
    this[SOCKET] = socketService;
    this[$HTTP] = $http;
    this[ANALYTICS_SERVICE] = analyticsService;

    this[QS] = queryString.parse($window.location.search);

    this.name = '';
    this.email = this[QS].email;
    this.role = '';
    this.currentStep = 0;
    this.steps = null;

    // load first template, choose download
    this.dashboardUrl = 'https://app.staff.com';
    this.template = 'app/pages/signup/partial-download-selection.html';
    this.password = '';

    // get available downloads
    this.downloads = downloadUrlsService;
    this.isMobile = md.mobile() !== null;

    this.determineDownload();
  }

  $onInit() {
    this[ANALYTICS_SERVICE].trackCustomEvent('clicked-invitation-link', {
      link: location.href,
    });
  }

  activate() {
    if (this.activating) {
      return;
    }

    const name = this.name;
    const email = this[QS].email;
    const password = this.password;

    let token;

    this.buttonClicked = true;
    if (this.form.$valid) {
      this.modifyForm('disable');
      this.activating = true;

      this[API].userRegister(name, email, password)
        .catch((err) => {
          if (this[$WINDOW].atatus) {
            this[$WINDOW].atatus.notify(err);
          }
        })
        .then(() => this[API].userLogin(email, password))
        .then(login => {
          token = login.token;
          this[API].setToken(token);
          this.token = token;
          return this[API].authorization();
        })
        .then(auth => {
          const userId = auth.id;
          const company = auth.companies[0];
          const companyId = company.oldCompanyId;
          this.role = company.role;

          if (this.role !== 'guest' && company && company.companySettings && company.companySettings.custom && company.companySettings.custom.browserExtensionEnabled) {
            this.steps = [0, 1, 2];
          } else {
            this.steps = [0, 1];
          }

          this[ANALYTICS_SERVICE].trackEvent(
            'succesfully-submitted-password', {
            userId,
            userName: name,
            userEmail: email,
            companyId,
            role: this.role,
          }
          );

          if (this.role === 'guest') {
            this.installationDone = true;
            this.goToDashboard();
          } else {
            if (company) {
              const workspaceId = company.id;

              this.checkFromApi()
                .then(() => this.checkFromSocket(token, userId, workspaceId));

              this[$INTERVAL](() => {
                if (!this.installationDone) {
                  this.checkFromApi();
                }
              }, 20000);
            }

            this.startDownload();
            this.currentStep = 1;
          }

        }).catch(() => this.activating = false);
    } else {
      this.modifyForm('enable');
      angular.element('input.ng-invalid').first().focus();
    }
  }

  startDownload() {
    this[ANALYTICS_SERVICE].trackCustomEvent('download-app', {
      os: this.os,
      type: 'interactive',
    });
    this[$WINDOW].location = this.download.interactiveUrl;
  }

  checkFromSocket(token, userId, workspaceId) {
    const defered = this[$Q].defer();
    const socket = this[SOCKET](token, userId, workspaceId);

    socket
      .subscribe()
      .connect()
      .on('notify', data => {
        if (data.resource === 'status' || data.resource === 'users/managed') {
          this[$TIMEOUT](() => {
            this.installationDone = true;
            defered.resolve();
          });
        }
      });

    return defered.promise;
  }

  checkFromApi() {
    return this[API]
      .authorization()
      .then(res => {
        const company = res.companies[0];
        this.role = company.role;
        if (this.role === 'admin' || this.role === 'manager') {
          angular.element('.skip-msg').html(`
                <br />
                Or you can
                <a href="${this.dashboardUrl}?token=${this.token}" class="underline">
                  skip the installation
                </a>
                if you are only using Time Doctor 2 to manage others and won't track your own work.
              `);
          angular.element('.skip-msg').show();
        }

        if (company.lastTrack) {
          this.installationDone = true;
        }
      });
  }

  modifyForm(action) {
    if (action === 'disable') {
      this.isValidating = true;
    } else {
      this.isValidating = false;
    }
  }

  determineDownload() {
    this.os = this[DEVICE_DETECTOR].os;
    if (this.os !== 'windows' && this.os !== 'linux' && this.os !== 'mac') {
      this.os = 'other';
    }
    this.downloads.then(res => {
      this.download = res[this.os];
    });
  }

  goToDashboard() {
    if (!this.installationDone) {
      angular.element('.install-error-modal').modal();
    } else {
      this.redirectToDashboard();
    }
  }

  redirectToDashboard() {
    let url = this.dashboardUrl;
    if (this.token) {
      url += `?token=${this.token}`;
    }

    this[$WINDOW].location = url;
  }

  nextStep() {
    if (!this.installationDone) {
      angular.element('.install-error-modal').modal();
    } else {
      this.currentStep++;
    }
  }

  skipExtension() {
    angular.element('.extension-error-modal').modal();
  }
}

export default ActivateController;
